class AthosCollection extends HTMLElement {
    static INIT_DELAY = 10;

    constructor() {
      super();

      this.productsLoaded = 0;
      this.resultsLoaded = 0;
    }

    connectedCallback() {
      this.athosReadyInterval = setInterval(() => {
        if (typeof athos !== 'undefined') {
          clearInterval(this.athosReadyInterval);

          if (athos.isEnabled()) {
            this.initController();
            this.attachEvents();
          }
          return;
        }

        if (!window.athosVariables?.siteId) {
          clearInterval(this.athosReadyInterval);
        }
      }, AthosCollection.INIT_DELAY);
    }

    disconnectedCallback() {
      clearInterval(this.athosReadyInterval);
    }

    attachEvents() {
      this.addEventListener('click', event => {
        const target = event.target;

        if (target.hasAttribute('data-load-more-btn')) {
          event.preventDefault();

          if (!this.controller.store.pagination.next) {
            this.hideLoadMore();

            return;
          }

          this.controller.store.pagination.next.url.go({ history: 'replace' });
        }

        if (target.hasAttribute('data-clear-all-btn')) {
          event.preventDefault();

          this.resultsLoaded = 0;
          this.productsLoaded = 0;

          const newUrlState = this.controller.store.services.urlManager.remove('filter');

          newUrlState.go({ history: 'replace' });
        }

        if (target.hasAttribute('data-filter-clear-btn')) {
          const field = target.getAttribute('data-filter-field');
          const urlManager = this.controller.urlManager;
          const currentFilters = urlManager.state.getIn(['filter', field]) || [];

          if (!currentFilters.length) {
            return;
          }

          this.resultsLoaded = 0;
          this.productsLoaded = 0;

          const newUrlState = urlManager.remove(['filter', field], currentFilters);

          newUrlState.go({ history: 'replace' });
        }
      });

      this.addEventListener('change', (event) => {
        const target = event.target;
        const sliderFilter = target.closest('[data-filter-value-slider]');
        const sortingItem = target.closest('[data-sorting-item]');

        if (sortingItem) {
          const activeSortingOption = sortingItem.querySelector('input[data-sorting-input]:checked');
          const [field, direction] = activeSortingOption.value.split(':');
          const sorting = this.controller.store.sorting;
          let targetSortingOption = sorting.options?.find(option => option.field === field && option.direction === direction);

          if (!targetSortingOption) {
            return;
          }

          this.resultsLoaded = 0;
          this.productsLoaded = 0;

          targetSortingOption.url.go({ history: 'replace' });
        }

        if (sliderFilter) {
          const fieldLow = sliderFilter.querySelector('[data-input-min-value]') || sliderFilter.querySelector('[data-input-range-min-value]');
          const fieldHigh = sliderFilter.querySelector('[data-input-max-value]') || sliderFilter.querySelector('[data-input-range-max-value]');
          const field = fieldLow.getAttribute('name') || fieldHigh.getAttribute('name');

          let valueMin = fieldLow?.value;
          let valueMax = fieldHigh?.value;

          this.resultsLoaded = 0;
          this.productsLoaded = 0;

          const urlManager = this.controller.urlManager;
          const newUrlState = urlManager.remove(['filter', field]).set(['filter', field], { low: valueMin, high: valueMax });

          newUrlState.go({ history: 'replace' });
        }

        if (target.hasAttribute('data-filter-value-checkbox')) {
          const facets = [...this.controller.store.facets];
          const field = target.getAttribute('name');
          const value = target.getAttribute('value');
          let targetFacet = facets.find(facet => facet.field === field);

          if (!targetFacet) {
            return;
          }

          let targetValue = targetFacet.values.find(item => item.value === value);

          if (!targetValue) {
            return;
          }

          if (targetValue) {
            this.resultsLoaded = 0;
            this.productsLoaded = 0;

            if (!targetValue.filtered) {
              targetValue.url.go({ history: 'replace' });
            } else {
              const newUrlState = targetValue.url.remove([field], value);

              newUrlState.go({ history: 'replace' });
            }
          }
        }
      });
    }

    initController() {
      const productsPerPage = Number(this.dataset.productsPerPage) || 20;

      this.controllerSettings = {
        id: window.athosVariables.template.name,
        globals: {
          filters: [],
          pagination: {
            pageSize: productsPerPage
          }
        },
        settings: {
          infinite: {},
          facets: {
            trim: false,
            pinFiltered: false,
            storeRange: true,
          }
        }
      }

      if (window.athosVariables.collection?.handle) {
        this.controllerSettings.globals.filters.push({
          field: 'collection_handle',
          value: window.athosVariables.collection.handle,
          type: 'value',
          background: true
        });
      }

      this.controller = athos.initController('collection', this.controllerSettings);

      this.controller.init();

      this.controller.search();

      this.controller.on('afterStore', async (eventData, next) => {
        const { controller, response } = eventData;
        const results = [...response.search.results].slice(this.resultsLoaded);
        const facets = [...controller.store.facets];

        this.resultsLoaded += results.length;

        await this.renderGlobalBanners();

        await this.renderProducts(results);

        this.generateLoadMore(response.search.pagination);

        this.initSorting(response.meta.sortOptions);
        this.initFilters(facets);

        if (window.athosVariables.template.name === 'search') {
          this.updateSearchResultsCount();
        }

        this.syncPageToHistory(response.search.pagination.page);

        await next();
      });
    }

    syncPageToHistory(page) {
      const url = new URL(window.location.href);

      if (page <= 1) {
          const currentPageParam = url.searchParams.get('page');
          if (currentPageParam !== null) {
           url.searchParams.delete('page');
           window.history.replaceState(window.history.state, '', url.toString());
         }

        return;
      } 
      
      if (url.searchParams.get('page') !== String(page)) {
        url.searchParams.set('page', page);
        window.history.replaceState(window.history.state, '', url.toString());
      }
    }

    async renderProducts(data) {
      const slots = data.map(item => {
        if (item.type === 'banner') {
          return { type: 'banner', html: item.value, position: item.config.position.index + 1 };
        }

        const url = item.mappings.core.url;
        const parts = url.split('/');
        const handle = parts[parts.length - 1].split('?')[0];

        return { type: 'product', handle };
      });

      const gridContainer = this.querySelector('[data-collection-list]');
      const templateGridItem = this.querySelector('#grid-item-template');

      if (data.length === 0) {
        gridContainer.replaceChildren();

        const templateGridNoResults = this.querySelector('#grid-no-results-template');
        const noResultsTemplate = templateGridNoResults.content.cloneNode(true);

        gridContainer.appendChild(noResultsTemplate);

        gridContainer.classList.remove('hidden');

        return;
      }

      const productHandles = slots.filter(slot => slot.type === 'product').map(slot => slot.handle);

      const currentPage = this.controller.store.pagination.page;
      const productCards = await athos.fetchProducts(productHandles, 'standard', currentPage);

      const isFirstRender = this.productsLoaded === 0;

      this.productsLoaded += productCards.length;

      const finalMarkup = await Promise.all(slots.map(async slot => {
        if (slot.type === 'product') {
          return productCards.shift();
        }
        if (slot.type === 'banner') {
          return await this.renderBanner(slot.html, 'inline', slot.position);
        }
      }));

      if (currentPage == 1 || isFirstRender) {
        gridContainer.replaceChildren();
      }

      finalMarkup.forEach(card => {
        if (!card) {
          return;
        }

        const gridItem = templateGridItem.content.cloneNode(true);
        const collectionItemContainer = gridItem.querySelector('[data-collection-item]');

        collectionItemContainer.appendChild(card);

        const gridClasses = collectionItemContainer.querySelector('[data-grid-classes]')?.getAttribute('data-grid-classes');

        if (gridClasses) {
          collectionItemContainer.classList.add(...gridClasses.split(' '));
        }

        gridContainer.appendChild(gridItem);
      });

      gridContainer.classList.remove('hidden');
    }

    async renderBanner(bannerScript, placement = 'inline', position) {
      const html = new DOMParser().parseFromString(bannerScript, 'text/html');
      const banner = html.querySelector('script');
      let hasError = false;

      if (!banner) {
        return;
      }

      const type = banner.dataset.bannerType;
      const wrapper = document.createElement('div');

      if (placement === 'inline') {
        wrapper.setAttribute('data-collection-item', 'banner');
        wrapper.classList.add('h-full', 'rounded-lg', 'overflow-hidden');
      }

      switch (type) {
        case 'image': {
          const imageElement = document.createElement('img');

          imageElement.src = banner.dataset.imageUrl;
          imageElement.alt = banner.dataset.targetTitle || '';
          imageElement.classList.add('w-full', 'h-full', 'object-cover');

          if (banner.dataset.targetUrl) {
            const linkElement = document.createElement('a');

            linkElement.classList.add('block', 'h-full');

            linkElement.href = banner.dataset.targetUrl;

            linkElement.appendChild(imageElement);

            wrapper.appendChild(linkElement);
          } else {
            wrapper.appendChild(imageElement);
          }

          break;
        }

        case 'html': {
          const cleanHtml = DOMPurify.sanitize(banner.dataset.bannerHtml, {
            ADD_ATTR: ['x-data', 'x-init', 'x-ref']
          });
          const parsed = new DOMParser().parseFromString(cleanHtml, 'text/html');
          let hasHotspotBanner = false;

          if (typeof cleanHtml === 'string' && cleanHtml.startsWith('hotspot-')) {
            const hotspotBanner = await this.generateHotspotBanner(cleanHtml);

            if (hotspotBanner) {
              wrapper.append(hotspotBanner);

              hasHotspotBanner = true;
            } else {
              hasError = true;
            }
          } else {
            if (parsed.body.children.length > 0) {
              wrapper.append(...parsed.body.children);
            } else if (parsed.body.textContent.trim().length > 0) {
              wrapper.textContent = parsed.body.textContent;
            } else {
              hasError = true;
            }
          }

          if (hasHotspotBanner && placement === 'inline') {
            const bannerPosition = position || 1;
            let promoHeightStart = Math.ceil(bannerPosition / 4.0);
            let promoHeightEnd = promoHeightStart + 1;
            let promoWidthStart = bannerPosition % 4;

            if (promoWidthStart === 0) {
              promoWidthStart = 4
            };

            let promoWidthEnd = promoWidthStart + 2;

            if (promoWidthEnd > 5) {
              let shift = promoWidthEnd - 4;

              promoWidthStart = Math.max(promoWidthStart - shift, 1);
              promoWidthEnd = 5;
            }

            let gridClassString = `h-full col-span-2 lg:row-start-${promoHeightStart} lg:row-end-${promoHeightEnd} lg:col-start-${promoWidthStart} lg:col-end-${promoWidthEnd}`;

            wrapper.setAttribute('data-grid-classes', gridClassString);
          }

          break;
        }

        case 'video': {
          const iframe = document.createElement('iframe');
          const videoUrl = banner.dataset.videoUrl;
          const videoID = videoUrl.match(/v=([^&]+)/)[1];
          let embedUrl = videoUrl;

          if (videoID) {
            embedUrl = `https://www.youtube.com/embed/${videoID}`;
          }

          iframe.src = embedUrl;
          iframe.width = '100%';
          iframe.height = '100%';
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('allowfullscreen', '');

          wrapper.appendChild(iframe);

          break;
        }
      }

      return !hasError ? wrapper : '';
    }

    async generateHotspotBanner(html) {
      const banner = document.createElement('div');
      const sectionId = html.replace('hotspot-', '');
      let hasBanner = false;

      banner.classList.add('h-full', 'relative');

      await fetch(window.Shopify.routes.root + `?section_id=${sectionId}`)
        .then(response => response.text())
        .then(data => {
          let html = new DOMParser().parseFromString(data, 'text/html');
          const section = html?.querySelector(`#shopify-section-${sectionId}`)

          if (!section) {
            return;
          }

          banner.append(...section.children);

          hasBanner = true;
        })
        .catch(error => {
          console.error(error);
        });

      return hasBanner ? banner : '';
    }

    async renderGlobalBanners() {
      const primaryBannersContainer = this.querySelector('[data-primary-banners]');
      const secondaryBannersContainer = this.querySelector('[data-secondary-banners]');
      const footerBannersContainer = this.querySelector('[data-footer-banners]');
      const primaryBanners = this.controller.store.merchandising.content.header;
      const secondaryBanners = this.controller.store.merchandising.content.banner;
      const footerBanners = this.controller.store.merchandising.content.footer;

      if (primaryBannersContainer && primaryBanners) {
        await this.appendGLobalBanners(primaryBannersContainer, primaryBanners);
      }

      if (secondaryBannersContainer && secondaryBanners) {
        await this.appendGLobalBanners(secondaryBannersContainer, secondaryBanners);
      }

      if (footerBannersContainer && footerBanners) {
        await this.appendGLobalBanners(footerBannersContainer, footerBanners);
      }
    }

    async appendGLobalBanners(container, bannersHtml) {
      if (!container || !bannersHtml) {
        return;
      }

      container.replaceChildren();

      const banners = await Promise.all(
        bannersHtml.map(bannerHtml => this.renderBanner(bannerHtml, 'global'))
      );

      banners.forEach(banner => {
        if (!banner) {
          return;
        }

        container.appendChild(banner);
      });
    }

    generateLoadMore(paginate) {
      const paginationContainer = this.querySelector('[data-pagination-container]');
      const templateLoadMore = this.querySelector('#load-more-template');

      if (!paginationContainer || !templateLoadMore || paginate.totalPages <= 1 || !this.controller.store.pagination.next) {
        this.hideLoadMore();

        return;
      }

      paginationContainer.replaceChildren();

      const loadMoreElements = templateLoadMore.content.cloneNode(true);

      loadMoreElements.querySelector('[data-products-loaded]').textContent = this.productsLoaded;
      loadMoreElements.querySelector('[data-total-products]').textContent = paginate.totalResults;

      paginationContainer.appendChild(loadMoreElements);

      paginationContainer.classList.remove('hidden');
    }

    hideLoadMore() {
      const paginationContainer = this.querySelector('[data-pagination-container]');

      if (!paginationContainer) {
        return;
      }

      paginationContainer.classList.add('hidden');
    }

    initSorting(sortOptions) {
      if (!sortOptions || sortOptions.length === 0) {
        return;
      }

      const filtersContainer = this.querySelector('#FacetFiltersForm');
      const templateSorting = this.querySelector('#sorting-template');
      const templateSortingOption = this.querySelector('#sorting-option-template');

      if (!filtersContainer || !templateSorting || !templateSortingOption) {
        return;
      }

      filtersContainer.querySelector('[data-sorting-item]')?.remove();

      const sortingItem = templateSorting.content.cloneNode(true);
      const sortionOptionsContainer = sortingItem.querySelector('[data-sortion-options]');

      if (!sortionOptionsContainer) {
        return;
      }

      sortOptions?.forEach(option => {
        const sortingOption = templateSortingOption.content.cloneNode(true);
        const optionName = sortingOption.querySelector('[data-option-name]');
        const optionInput = sortingOption.querySelector('[data-sorting-input]');

        if (optionName) {
          optionName.textContent = option.label;
        }

        if (optionInput) {
          optionInput.setAttribute('value', `${option.field}:${option.direction}`);
          optionInput.setAttribute('x-on:click', `sort='${option.label}'; $dispatch('set-sortby', { sortByActive: '${option.label}' })`);

          if (option.active) {
            optionInput.setAttribute('checked', true);
          }
        }

        sortionOptionsContainer.appendChild(sortingOption);
      });

      filtersContainer.appendChild(sortingItem);

      filtersContainer.classList.remove('hidden');
    }

    initFilters(facets) {
      if (facets.length === 0) {
        return;
      }

      this.generateResultsCounter();
      this.toggleClearAllFiltersLink(facets);
      this.generateFiltersPreview(facets);
      this.updateMoreFiltersButton(facets);
      this.updateMobileFacetsButton(facets);
      this.generateFiltersModal(facets);
      this.toggleModalClearAllFiltersButton(facets);
    }

    generateResultsCounter() {
      const resultsCountElements = this.querySelectorAll('[data-results-count]');

      resultsCountElements.forEach(resultCountElement => {
        resultCountElement.textContent = `${this.controller.store.pagination.totalResults} ${this.controller.store.pagination.totalResults > 1 ? window.athosVariables.strings.productCount.other : window.athosVariables.strings.productCount.one }`;
      })
    }

    toggleClearAllFiltersLink(facets) {
      const clearAllFiltersContainer = this.querySelector('#facetsClearAllBar');
      const hasActiveFilters = facets.filter(facet => facet.filtered).length > 0;

      if (!clearAllFiltersContainer) {
        return;
      }

      clearAllFiltersContainer.classList.toggle('hidden', !hasActiveFilters);
    }

    generateFiltersPreview(facets) {
      const filtersPreviewContainer = this.querySelector('[data-facets-display]');
      const facetPreviewTemplate = this.querySelector('#facet-preview-template');

      if (!filtersPreviewContainer || !facetPreviewTemplate) {
        return;
      }

      filtersPreviewContainer.querySelectorAll('[data-facet-preview]').forEach(facetPreview => facetPreview.remove());

      if (facets.length === 0) {
        filtersPreviewContainer.classList.add('invisible');

        return;
      }

      facets.forEach((facet, index) => {
        const facetPreviewTemplateClone = facetPreviewTemplate.content.cloneNode(true);
        const facetPreviewElement = facetPreviewTemplateClone.querySelector('[data-facet-preview]');
        const facetIndex = index + 1;
        const filterLabel = facetPreviewTemplateClone.querySelector('[data-filter-label]');
        const filterCounter = facetPreviewTemplateClone.querySelector('[data-filter-counter]');
        const sliderValues = facetPreviewTemplateClone.querySelector('[data-slider-values]');
        const sliderValueLow = facetPreviewTemplateClone.querySelector('[data-slider-low-value]');
        const sliderValueHigh = facetPreviewTemplateClone.querySelector('[data-slider-high-value]');

        filterLabel.textContent = facet.label;

        if (facet.filtered) {
          if (facet.display === 'slider') {
            filterLabel.remove();
            filterCounter.remove();

            sliderValueLow.textContent = Shopify.formatMoney(facet.active.low * 100);
            sliderValueHigh.textContent = Shopify.formatMoney(facet.active.high * 100);
          } else {
            sliderValues.remove();

            filterCounter.textContent = `(${facet.values.filter(value => value.filtered).length})`;

            filterCounter.classList.remove('hidden');
          }

          facetPreviewTemplateClone.querySelector('[data-label-container]').classList.add('bg-white');
        } else {
          sliderValues.remove();
          filterCounter.remove();
        }

        if (facetIndex === 2 || facetIndex === 3) {
          facetPreviewElement.classList.add('hidden', 'lg:flex', 'xl:flex');
        }

        if (facetIndex === 4) {
          facetPreviewElement.classList.add('hidden', 'xl:flex');
        }

        if (facetIndex > 4) {
          facetPreviewElement.classList.add('hidden', 'xl:hidden');
        }

        if (facetIndex < 3) {
          facetPreviewElement.classList.add('flex');
        }

        facetPreviewElement.setAttribute('x-on:click', `$dispatch('show-collection-filters', { showModal: true, filtertype: '${facet.label}' });`);

        filtersPreviewContainer.appendChild(facetPreviewTemplateClone);
      });

      filtersPreviewContainer.classList.remove('invisible');  
    }

    updateMoreFiltersButton(facets) {
      const button = this.querySelector('[data-more-filters-btn]');
      const facetsSize = facets.length;

      if (!button) {
        return;
      }

      if (facetsSize < 5) {
        button.classList.add('hidden');

        button.classList.remove('flex', 'md:flex', 'lg:hidden', 'lg:flex', 'xl:flex');
      } else if (facetsSize === 5) {
        button.classList.add('flex', 'md:flex', 'lg:hidden');

        button.classList.remove('hidden', 'lg:flex', 'xl:flex');
      } else if (facetsSize >= 6) {
        button.classList.add('md:flex', 'lg:flex', 'xl:flex');

        button.classList.remove('hidden', 'flex', 'lg:hidden');
      }
    }

    updateMobileFacetsButton(facets) {
      const wrapper = this.querySelector('[data-facets-display-wrapper]');
      const button = wrapper?.querySelector('[data-facets-btn]');
      const buttonCounter = button?.querySelector('[data-facets-counter]');
      const activeFiltersCount = facets.reduce((accumulator, currentValue) => {
        if (!currentValue.filtered) {
          return accumulator;
        }

        let activeValues = 0;

        if (currentValue.display === 'slider') {
          activeValues = 1;
        } else {
          activeValues = currentValue.values.filter(value => value.filtered).length;
        }

        return accumulator + activeValues;
      }, 0);

      if (!wrapper || !button) {
        return;
      }

      button.classList.toggle('bg-white', activeFiltersCount > 0);

      if (buttonCounter) {
        buttonCounter?.classList?.toggle('hidden', activeFiltersCount === 0);

        buttonCounter.textContent = `(${activeFiltersCount})`;
      }
    }

    generateFiltersModal(facets) {
      const filtersContainer = this.querySelector('#FacetFiltersForm');
      const templateFilterItem = this.querySelector('#filter-item-template');

      if (!filtersContainer || !templateFilterItem) {
        return;
      }

      filtersContainer.querySelectorAll('[data-facet-item]').forEach(facetPreview => facetPreview.remove());

      facets.forEach((facet, index) => {
        const filterItem = templateFilterItem.content.cloneNode(true);
        const filterWrapper = filterItem.querySelector('[data-filter-wrapper]');
        const filterTitle = filterItem.querySelector('[data-filter-title]');
        const filterActiveValues = filterItem.querySelector('[data-filter-active-values]');
        const filterArrow = filterItem.querySelector('[data-filter-arrow]');
        const filterBody = filterItem.querySelector('[data-filter-body]');
        const filterClear = filterItem.querySelector('[data-filter-clear]');
        const filterClearLabel = filterItem.querySelector('[data-filter-clear-label]');
        const filterClearBtn = filterItem.querySelector('[data-filter-clear-btn]');
        const filterValues = filterItem.querySelector('[data-filter-values]');
        const isSlider = facet.display === 'slider';

        if (filterWrapper) {
          filterWrapper.setAttribute('x-bind:class', `filtertype=='${facet.label}' ? 'collection-filter-active' : 'collection-filter'`);
          filterWrapper.setAttribute('x-on:click', `filtertype = (filtertype === '${facet.label}' ? null : '${facet.label}')`);
        }

        if (filterTitle) {
          filterTitle.textContent = facet.label;
        }

        if (filterActiveValues) {
          const activeFilters = () => {
            if (facet.filtered) {
              if (facet.display == 'slider') {
                return `${Shopify.formatMoney(facet.active.low * 100)} ${facet.formatSeparator} ${Shopify.formatMoney(facet.active.high * 100)}`;
              } else {
                return facet.values.filter(value => value.filtered).map(value => value.label)
              }
            }

            return window.athosVariables.strings.facets.all;
          }
          filterActiveValues.textContent = activeFilters();
        }

        if (filterArrow) {
          filterArrow.setAttribute('x-bind:class', `filtertype=='${facet.label}' ? '-rotate-90' : 'rotate-180'`);
        }

        if (filterBody) {
          filterBody.setAttribute('x-show', `filtertype=='${facet.label}'`);
        }

        if (filterClear) {
          if (!isSlider) {
            const activeValuesCount = facet.values.filter(value => value.filtered).length;

            filterClearLabel.textContent = window.athosVariables.strings.facets.xSelected.replace('[[count]]', activeValuesCount);

            filterClearBtn.setAttribute('data-filter-field', facet.field);

            if (activeValuesCount === 0) {
              filterClear.remove();
            }
          } else {
            filterClear.remove();
          }
        }

        if (filterValues) {
          filterValues.setAttribute('data-index', index);

          if (facet.field === 'ss_price') {
            const templateFilterSlider = this.querySelector('#filter-slider-template');

            if (!templateFilterSlider) {
              return;
            }

            const filterSlider = templateFilterSlider.content.cloneNode(true);

            const inputRangeMinValue = filterSlider.querySelector('[data-input-range-min-value]');
            const inputRangeMaxValue = filterSlider.querySelector('[data-input-range-max-value]');
            const inputMinValue = filterSlider.querySelector('[data-input-min-value]');
            const inputMaxValue = filterSlider.querySelector('[data-input-max-value]');

            if (inputRangeMinValue) {
              inputRangeMinValue.setAttribute('min', 0);
              inputRangeMinValue.setAttribute('max', facet.range.high);
              inputRangeMinValue.setAttribute('value', facet.active.low);
              inputRangeMinValue.setAttribute('step', facet.step);
              inputRangeMinValue.setAttribute('name', facet.field);
              inputRangeMinValue.setAttribute('id', `Filter-${facet.label}-low`);
            }

            if (inputRangeMaxValue) {
              inputRangeMaxValue.setAttribute('min', 0);
              inputRangeMaxValue.setAttribute('max', facet.range.high);
              inputRangeMaxValue.setAttribute('value', facet.active.high);
              inputRangeMaxValue.setAttribute('step', facet.step);
              inputRangeMaxValue.setAttribute('name', facet.field);
              inputRangeMaxValue.setAttribute('id', `Filter-${facet.label}-high`);
            }

            if (inputMinValue) {
              inputMinValue.setAttribute('value', facet.active.low);
              inputMinValue.setAttribute('name', facet.field);
              inputMinValue.setAttribute('id', `Filter-${facet.label}-low`);
            }

            if (inputMaxValue) {
              inputMaxValue.setAttribute('value', facet.active.high);
              inputMaxValue.setAttribute('name', facet.field);
              inputMaxValue.setAttribute('id', `Filter-${facet.label}-high`);
            }

            filterValues.appendChild(filterSlider);
          } else {
            const templateFilterValue = this.querySelector('#filter-value-template');

            if (!templateFilterValue) {
              return;
            }

            facet.values.forEach((value, index) => {
              const filterValue = templateFilterValue.content.cloneNode(true);
              const valueWrapper = filterValue.querySelector('[data-filter-value-wrapper]');
              const valueSwatch = filterValue.querySelector('[data-filter-value-swatch]');
              const valueLabel = filterValue.querySelector('[data-filter-value-label]');
              const valueCount = filterValue.querySelector('[data-filter-value-count]');
              const valueCheckbox = filterValue.querySelector('[data-filter-value-checkbox]');

              if (valueWrapper) {
                valueWrapper.setAttribute('for', `Filter-${value.label}-${index}`);

                if (value.count === 0) {
                  valueWrapper.classList.add('opacity-50', 'cursor-not-allowed');
                } else {
                  valueWrapper.classList.add('cursor-pointer');
                }
              }

              if (valueSwatch) {
                const label = facet.label?.toLowerCase();
                const valueLabelLowerCase = value.label?.toLowerCase()

                if (label === 'colour' || label === 'color') {
                  const colourObject = swatchColoursObjects.find(swatchColour => swatchColour.colour.toLowerCase() == valueLabelLowerCase);

                  if (colourObject) {
                    const imageTag = document.createElement('img');

                    imageTag.setAttribute('src', colourObject.image.url);
                    imageTag.setAttribute('width', colourObject.image.width);
                    imageTag.setAttribute('height', colourObject.image.height);

                    imageTag.classList.add('cursor-pointer', 'w-full', 'mix-blend-multiply', 'border', 'border-transparent', 'p-[2px]', 'rounded-[5px]');

                    imageTag.setAttribute('alt', value.label);

                    valueSwatch.classList.add('w-[35px]');

                    valueSwatch.appendChild(imageTag);
                  } else {
                    valueSwatch.remove();
                  }
                } else if (label === 'base') {
                  const baseObject = swatchBaseObjects.find(swatchBase => swatchBase.facet.toLowerCase() == valueLabelLowerCase);

                  if (baseObject) {
                    const imageTag = document.createElement('img');

                    imageTag.setAttribute('src', baseObject.image.url);
                    imageTag.setAttribute('width', baseObject.image.width);
                    imageTag.setAttribute('height', baseObject.image.height);

                    imageTag.classList.add('cursor-pointer', 'w-full', 'mix-blend-multiply', 'border', 'border-transparent', 'p-[2px]', 'rounded-[5px]');

                    if (value.filtered) {
                      imageTag.classList.add('!border-current');
                    }

                    imageTag.setAttribute('alt', value.label);

                    valueSwatch.classList.add('w-[57px]');

                    valueSwatch.appendChild(imageTag);
                  } else {
                    valueSwatch.remove();
                  }
                } else {
                  valueSwatch.remove();
                }
              }

              if (valueLabel) {
                valueLabel.textContent = value.label;
              }

              if (valueCount) {
                valueCount.textContent = `(${value.count})`;
              }

              if (valueCheckbox) {
                valueCheckbox.setAttribute('name', facet.field);
                valueCheckbox.setAttribute('value', value.value);
                valueCheckbox.setAttribute('id', `Filter-${value.label}-${index}`);

                if (value.filtered) {
                  valueCheckbox.setAttribute('checked', true);
                }

                if (value.count === 0) {
                  valueCheckbox.setAttribute('disabled', true);
                }
              }

              filterValues.appendChild(filterValue);
            });
          }
        }

        filtersContainer.appendChild(filterItem);
      });

      filtersContainer.classList.remove('hidden');
    }

    toggleModalClearAllFiltersButton(facets) {
      const clearAllFiltersContainer = this.querySelector('#facetsClearAll');
      const hasActiveFilters = facets.filter(facet => facet.filtered).length > 0;

      if (!clearAllFiltersContainer) {
        return;
      }

      clearAllFiltersContainer.classList.toggle('hidden', !hasActiveFilters);
    }

    updateSearchResultsCount() {
      const productCountsElement = this.querySelector('#ProductCount');
      const resultsMessageContainer = this.querySelector('[data-results-message]');
      const searchResultsCount = this.controller.store.pagination.totalResults;
      const pageTitle = document.querySelector('title');

      if (productCountsElement) {
        productCountsElement.textContent = `(${searchResultsCount})`;
      }

      if (resultsMessageContainer) {
        resultsMessageContainer.replaceChildren();

        const templateResultsMessage = this.querySelector('#search-results-message');
        const resultsMessage = templateResultsMessage.content.cloneNode(true);

        if (searchResultsCount > 0) {
          const resultsWithCountAndTermMessage = resultsMessage.querySelector('[data-results-with-count-and-term]');

          if (resultsWithCountAndTermMessage) {
            resultsWithCountAndTermMessage.textContent = resultsWithCountAndTermMessage.textContent.replace('[[resultsCount]]', searchResultsCount);
          }

          resultsMessage.querySelector('[data-no-results]')?.remove();
        } else {
          resultsMessage.querySelector('[data-results-with-count-and-term]')?.remove();
        }

        resultsMessageContainer.appendChild(resultsMessage);

        resultsMessageContainer.classList.remove('hidden');
      }

      pageTitle.textContent = pageTitle.textContent.replace(this.dataset.shopifySearchResultsCount, searchResultsCount);
    }
  }
  customElements.define('athos-collection', AthosCollection);
